$(function(){
    if($('#permissions').length) {
        $('#permissions').selectpicker({
            selectAllText: Lang.get('messages.select_all_text'),
            deselectAllText: Lang.get('messages.deselect_all_text')
        });
    }

    if($('#companies').length){
        $('#companies').selectpicker();
    }
    if($('#staff').length){
        $('#staff').selectpicker();
    }

    $('#is_agency').change(function(){
        let select = $('#companies');
        $.post("/ajax/users/related-companies", {'is_agency': $(this).is(':checked') }, function (json) {
            if (json.success === true) {
                select.empty();
                $.each(json.companies, function(key, company){
                    select.append('<option value="'+company.Id_Emp+'">'+company.Nom_Emp+'</option>');
                })
                select.selectpicker('refresh');
            }
        });
    });

    $.validator.addMethod("pwcheck", function(value) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(value);
    });

    $('#expiredPwd').validate({
        rules: {
            current_password: {
                required: true
            },
            password: {
                required: true,
                pwcheck: true,
                minlength: 8,
                maxlength: 50
            },
            password_confirmation: {
                required: true,
                equalTo: "#password",
                minlength: 8,
                maxlength: 50
            }
        },

        messages: {
            current_password: {
                required: Lang.get('messages.password_required')
            },
            password: {
                required: Lang.get('messages.password_required'),
                minlength: Lang.get('messages.password_minlength'),
                pwcheck: Lang.get('messages.password_pwcheck')
            },
            password_confirm: {
                required: Lang.get('messages.password_required'),
                minlength: Lang.get('messages.password_minlength'),
                equalTo: Lang.get('messages.password_equalto')
            }
        },

        invalidHandler: function(form, validator) {
            //$('.passwordHolder label.error').hide();
        }
    });

    $('#resetPwd').validate({
        rules: {
            password: {
                required: true,
                pwcheck: true,
                minlength: 8,
                maxlength: 50
            },
            password_confirmation: {
                required: true,
                equalTo: "#password",
                minlength: 8,
                maxlength: 50
            }
        },

        messages: {
            password: {
                required: Lang.get('messages.password_required'),
                minlength: Lang.get('messages.password_minlength'),
                pwcheck: Lang.get('messages.password_pwcheck')
            },
            password_confirmation: {
                required: Lang.get('messages.password_required'),
                minlength: Lang.get('messages.password_minlength'),
                equalTo: Lang.get('messages.password_equalto')
            }
        },

        invalidHandler: function(form, validator) {
            //$('.passwordHolder label.error').hide();
        }
    });
});

$(document).on("click", "#btnOrphanUsers", function(e){
    e.preventDefault();
    $.get("/ajax/companies/orphan", function(json){
        Swal.fire({
            title: "<strong>Usuaris <u>orfes</u></strong>",
            width: "1000px",
            html: json.view,
            showCloseButton: true,
        });
    }, 'json');
});
